module.exports = __webpack_public_path__ + "media/customizations/bigsky/back-c357cd99d95cbf98db0a9ff8e2b6a05a.jpg";